import { useRedirect } from "../../hooks";
import { ContactForm } from "../forms/";
import { Map } from "../elements/";

import styles from "../../assets/styles/cherries.module.scss";
import image from "../../assets/images/cherries/cherries-1.jpg";


import { CherriesFormv2, Contact } from "../partials";
import laurent from "../../assets/images/cherries/overview/laurent.jpg";
import stephanie from "../../assets/images/cherries/overview/stephanie.jpg";

const Cherries = () => {
  const { redirect } = useRedirect();

  return (
			<main className={styles.main}>
				<div className={styles.imgContainer}>
					<img src={image} alt="" />
					<div
						className={styles.cta}
						onClick={() => redirect("/kersen/gallerij")}
					>
						<i className="fas fa-camera" />
						<span>Bekijk meer foto's hier</span>
					</div>
				</div>

				<section className={styles.info}>
					<h1 className="title">Onze kersen</h1>

					<p>
						<strong>Beste kersenklanten</strong> <br />
						<br />
            <p>
              Graag informeren wij u dat <strong>woensdag 30 juli</strong> onze laatste verkoopdag van dit <strong>kersenseizoen 2025</strong> zal zijn. Wij hopen u dan ook de komende dagen nog te mogen verwelkomen.
            </p>

						<br />
						<p>
							U kunt via onderstaand bestelformulier{" "}
							<strong>kersen reserveren</strong>. Uw geplaatste bestelling kan
							nadien afgehaald worden in onze verkoopsruimte van Hoeve
							Engelendael. Naast online bestellen is het ook mogelijk om ons{" "}
							<strong>telefonisch</strong> te contacteren via{" "}
							<strong>0479 25 44 60</strong>. Daarnaast bent u ook welkom om ter
							plaatse in de winkel kersen te kopen zolang de voorraad strekt.
						</p>
						<br />
						<br />
						<strong>Het Engelendael team</strong>
					</p>

					{/* <p>
            <strong>Beste kersenklanten,</strong>
            <br />
            <br />
            <p>
              We zijn weer volop bezig met de voorbereidingen van het komende
              kersenseizoen. Ben of ken je iemand van 16 jaar of ouder, woon je
              in de streek van Sint-Jan-in-Eremo en heb je zin in een
              vakantiejob tussen de zoete kersen van begin juli tot begin
              augustus? Interesse? Neem dan gerust contact op via het nummer
              0479/25.44.60 of <a href="/contact">klik hier</a> om contact op te
              nemen via het contact formulier.
            </p>
            <br />
            <br />
            Houd onze updates in de gaten voor meer informatie over het komende
            seizoen. We hopen u in 2025 opnieuw te mogen verwelkomen en samen
            het kersenseizoen te beleven.
            <br />
            <br />
            <strong>Het Engelendael team</strong>
            <div className={styles.images}>
              <img src={stephanie} alt="Stephanie bij boer steven" />
              <img src={laurent} alt="Laurent bij delhaize" />
            </div>
          </p> */}
				</section>

				<section className={styles.openingHoursContainer}>
					<h2 className="title">Openingsuren</h2>
					<section className={styles.openingHours}>
						<div>
							<strong>Woensdag</strong>
							<span>13:00 - 18:00</span>
						</div>

						<div>
							<strong>Zaterdag</strong>
							<span>10:00 - 12:00</span>
							<span>13:00 - 18:00</span>
						</div>

						<div>
							<strong>Zondag</strong>
							<span>10:00 - 12:00</span>
							<span>13:00 - 18:00</span>
						</div>
					</section>
				</section>

				<section id="cherriesForm" className={styles.cherriesForm}>
					<h2 className="title">Bestel uw kersen</h2>
					<CherriesFormv2 />
				</section>

				<Contact page="cherries" />
				<Map />
			</main>
		);
};

export default Cherries;
